import { useId, type ReactNode } from 'react';

import { apiHatasiMi } from '../api/hata';

/**
 * TEMEL ARAYÜZ BİLEŞENLERİ.
 *
 * Bileşen kütüphanesi kurulmadı: Bölüm 1'de dört ekran var, üçü form. Erken
 * soyutlama ikinci ekranın ihtiyacını bilmeden yapılan tahmindir. Ekran
 * sayısı arttıkça buradan ayrıştırılacak.
 *
 * `Sekme` 0.30.0'da BURAYA TAŞINDI. `PuantajDenetimi` içinde yereldi; rehber
 * ekranı da sekme kullanıyor ve üçüncü bir kopya doğmadan çıkarıldı — biri
 * düzeltilip diğerleri geride kalmasın.
 */

export function Dugme({
  cocuk,
  tur = 'birincil',
  bekliyor = false,
  gonderMi = false,
  tikla,
  pasif = false,
}: {
  cocuk: ReactNode;
  tur?: 'birincil' | 'ikincil' | 'tehlike';
  bekliyor?: boolean;
  gonderMi?: boolean;
  tikla?: () => void;
  pasif?: boolean;
}) {
  const bicimler: Record<string, string> = {
    birincil: 'bg-kurum-600 text-white hover:bg-kurum-700',
    ikincil: 'bg-white text-slate-700 border border-slate-300 hover:bg-slate-50',
    tehlike: 'bg-red-600 text-white hover:bg-red-700',
  };

  return (
    <button
      type={gonderMi ? 'submit' : 'button'}
      onClick={tikla}
      disabled={pasif || bekliyor}
      className={`inline-flex items-center justify-center rounded-md px-4 py-2 text-sm font-medium transition disabled:cursor-not-allowed disabled:opacity-50 ${bicimler[tur] ?? ''}`}
    >
      {bekliyor ? 'Lütfen bekleyin…' : cocuk}
    </button>
  );
}

export function Alan({
  etiket,
  deger,
  degisti,
  tur = 'text',
  hatalar,
  otomatikTamamla,
  ipucu,
}: {
  etiket: string;
  deger: string;
  degisti: (yeni: string) => void;
  tur?: 'text' | 'password';
  hatalar?: string[];
  otomatikTamamla?: string;
  ipucu?: string;
}) {
  const hataliMi = (hatalar?.length ?? 0) > 0;

  return (
    <label className="block">
      <span className="mb-1 block text-sm font-medium text-slate-700">{etiket}</span>
      <input
        type={tur}
        value={deger}
        autoComplete={otomatikTamamla}
        onChange={(olay) => degisti(olay.target.value)}
        className={`w-full rounded-md border px-3 py-2 text-sm outline-none focus:ring-2 ${
          hataliMi
            ? 'border-red-400 focus:ring-red-200'
            : 'border-slate-300 focus:border-kurum-500 focus:ring-kurum-100'
        }`}
      />
      {ipucu && !hataliMi && <span className="mt-1 block text-xs text-slate-500">{ipucu}</span>}
      {hatalar?.map((h) => (
        <span key={h} className="mt-1 block text-xs text-red-600">
          {h}
        </span>
      ))}
    </label>
  );
}

/**
 * HATA KUTUSU.
 *
 * Sunucunun `baslik` ve `mesaj` alanları KULLANICIYA GÖSTERİLMEK ÜZERE
 * Türkçe yazıldı — veritabanı tetikleyicilerinin ürettiği gerekçeli mesajlar
 * dahil. Yeniden yazmak gerekçeyi kaybettirir.
 */
export function HataKutusu({ hata }: { hata: unknown }) {
  if (!hata) return null;

  if (!apiHatasiMi(hata)) {
    return (
      <div className="rounded-md border border-red-200 bg-red-50 p-3 text-sm text-red-800">
        Beklenmeyen bir hata oluştu.
      </div>
    );
  }

  return (
    <div className="rounded-md border border-red-200 bg-red-50 p-3 text-sm text-red-800">
      <p className="font-medium">{hata.baslik}</p>
      <p className="mt-0.5">{hata.message}</p>
    </div>
  );
}

export function Kart({
  baslik,
  aciklama,
  cocuk,
}: {
  baslik: string;
  aciklama?: string;
  cocuk: ReactNode;
}) {
  return (
    <div className="w-full max-w-md rounded-lg border border-slate-200 bg-white p-6 shadow-sm">
      <h1 className="text-lg font-semibold text-slate-900">{baslik}</h1>
      {aciklama && <p className="mt-1 text-sm text-slate-600">{aciklama}</p>}
      <div className="mt-5">{cocuk}</div>
    </div>
  );
}

/**
 * SEKME DÜĞMESİ.
 *
 * Yetkiye göre gizlenen sekmeler `etkin` durumunu ÇAĞIRANDAN alır; seçim
 * durumu burada tutulmaz. Sekme kendi durumunu saklasaydı, yetkiler geç
 * geldiğinde türetilen varsayılan sekme (bkz. SÖZLEŞME §5) ile çakışırdı.
 */
export function Sekme({
  etkin,
  tikla,
  etiket,
}: {
  etkin: boolean;
  tikla: () => void;
  etiket: string;
}) {
  return (
    <button
      type="button"
      onClick={tikla}
      aria-current={etkin ? 'page' : undefined}
      className={`-mb-px border-b-2 px-3 py-2 text-sm ${
        etkin
          ? 'border-kurum-600 font-medium text-kurum-700'
          : 'border-transparent text-slate-600 hover:text-slate-900'
      }`}
    >
      {etiket}
    </button>
  );
}

/**
 * DAR METİN ALANI — ızgara içinde kullanılır.
 *
 * `Alan`dan AYRI: `Alan` tam genişlikte, alan hatalarını (`hatalar`) taşır ve
 * giriş formları için yazılmıştı. Bu bileşen tarih/saat türlerini destekler ve
 * diyalog ızgaralarında yan yana durur.
 *
 * `Ayarlar` ile `AyarlarTakvim` arasında paylaşıldığı için BURADA duruyor;
 * ekranlardan birine konsaydı ikisi birbirini içe aktarır ve DÖNGÜSEL
 * bağımlılık oluşurdu.
 *
 * İPUCU `aria-describedby` İLE BAĞLANIR, etiketin İÇİNE konmaz. İçine
 * konsaydı alanın erişilebilir adı "Yeni değerSayısal ayarlar da METİN
 * taşır…" olurdu; ekran okuyucu bunun tamamını alan adı diye okur.
 */
export function Metin({
  etiket,
  deger,
  degisti,
  tur = 'text',
  ipucu,
}: {
  etiket: string;
  deger: string;
  degisti: (yeni: string) => void;
  tur?: 'text' | 'date' | 'time';
  ipucu?: string;
}) {
  const ipucuId = useId();

  return (
    <div>
      <label className="block">
        <span className="mb-1 block text-sm font-medium text-slate-700">{etiket}</span>
        <input
          type={tur}
          value={deger}
          onChange={(olay) => degisti(olay.target.value)}
          aria-describedby={ipucu === undefined ? undefined : ipucuId}
          className="w-full rounded-md border border-slate-300 px-3 py-2 text-sm outline-none focus:border-kurum-500 focus:ring-2 focus:ring-kurum-100"
        />
      </label>
      {ipucu !== undefined && (
        <span id={ipucuId} className="mt-1 block text-xs text-slate-500">
          {ipucu}
        </span>
      )}
    </div>
  );
}

/**
 * ÇOK SATIRLI ALAN — gerekçe ve açıklama kutuları.
 *
 * Beş ayrı yerde aynı `textarea` işaretlemesi kopyalanıyordu. İpucu burada da
 * `aria-describedby` ile bağlanır; etiketin içine konsaydı erişilebilir ad
 * ipucu metnini de yutardı.
 */
export function CokSatir({
  etiket,
  deger,
  degisti,
  satir = 3,
  ipucu,
}: {
  etiket: string;
  deger: string;
  degisti: (yeni: string) => void;
  satir?: number;
  ipucu?: string;
}) {
  const ipucuId = useId();

  return (
    <div>
      <label className="block">
        <span className="mb-1 block text-sm font-medium text-slate-700">{etiket}</span>
        <textarea
          value={deger}
          rows={satir}
          onChange={(olay) => degisti(olay.target.value)}
          aria-describedby={ipucu === undefined ? undefined : ipucuId}
          className="w-full resize-y rounded-md border border-slate-300 px-3 py-2 text-sm outline-none focus:border-kurum-500 focus:ring-2 focus:ring-kurum-100"
        />
      </label>
      {ipucu !== undefined && (
        <span id={ipucuId} className="mt-1 block text-xs text-slate-500">
          {ipucu}
        </span>
      )}
    </div>
  );
}
